import React from "react";
import './PrivacyPolicy.css';
import HomeLeft from "../Components/HomeLeft";
import HomeRight from "../Components/HomeRight";

const PrivacyPolicy = () => {
    return (
        <>
            <div className="row">
                <div className="col-1 leftcol">
                </div>
                <div className="col-10 middlecol">
                    <div className="row g-5 privacy">
                        <div className="col-lg-12">
                            <h2>SAAD MOTORS CO., LTD. (THAILAND) — PRIVACY POLICY</h2>
                            <h3>Privacy Policy</h3>
                            <hr className="title-line"></hr>
                            <p>At Saad Motors Co., Ltd. (Thailand), we respect and value the privacy of our customers, business partners, and website visitors. This Privacy Policy explains how we collect, use, maintain, protect, and disclose personal information obtained through our website and business activities.</p>
                            <p>We are committed to handling personal information responsibly, transparently, and in accordance with applicable privacy and data protection laws and regulations.</p>
                            <h3>1. Personal Information Protection</h3>
                            <hr className="title-line"></hr>
                            <p>Saad Motors Co., Ltd. maintains appropriate organizational and technical measures to protect personal information against unauthorized access, loss, misuse, alteration, disclosure, or destruction.</p>
                            <p>We have established internal procedures and designated responsible personnel to oversee the proper management and protection of personal information.</p>
                            <p>Personal information will only be collected, processed, and used for legitimate business purposes and within the scope communicated to the individual concerned, unless otherwise permitted or required by applicable law.</p>
                            <h3>Information We Collect</h3>
                            <hr className="title-line"></hr>
                            <p>Depending on the nature of your interaction with Saad Motors Co., Ltd., we may collect the following information:</p>   
                            <p># Personal and Contact Information</p>                         
                            <ul>
                                <li>Full name</li>
                                <li>Residential or business address</li>
                                <li>Telephone or mobile number</li>
                                <li>Email address</li>
                                <li>Company or organization information</li>
                                <li>Other information voluntarily provided by you</li>
                            </ul>
                            <p>Website and Technical Information</p>
                            <p>When you visit or use our website, certain technical information may be automatically collected, including:</p>
                            <ul>
                                <li>IP address</li>
                                <li>Browser and device information</li>
                                <li>Cookies and similar technologies</li>
                                <li>Website usage and browsing information</li>
                                <li>Device identifiers</li>
                                <li>General location information where applicable</li>
                            </ul>
                            <p>We collect such information only where permitted by applicable law and, where required, with appropriate consent.</p>
                            <h3>Purpose of Using Personal Information</h3>
                            <hr className="title-line"></hr>
                            <p>Saad Motors Co., Ltd. may use personal information for the following purposes:</p>
                            <ul class="mb-3 ps-4">
                                <li class="mb-2">To provide, manage, and improve our products and services.</li>
                                <li class="mb-2">To process customer inquiries, requests, transactions, and business communications.</li>
                                <li class="mb-2">To communicate with customers regarding services, orders, updates, and other relevant matters.</li>
                                <li class="mb-2">To maintain business and customer relationships.</li>
                                <li class="mb-2">To manage business partners, suppliers, and other commercial relationships.</li>
                                <li class="mb-2">To comply with applicable laws, regulations, legal obligations, and lawful requests from authorities.</li>
                                <li class="mb-2">To protect the rights, property, safety, and legitimate interests of Saad Motors Co., Ltd., our customers, and other relevant parties.</li>
                                <li class="mb-2">To maintain website security and improve website functionality and user experience.</li>
                                <li>To perform other activities directly related to the purposes described above.</li>
                            </ul>
                            <p>We will not use personal information for purposes that are incompatible with the purposes for which it was collected unless permitted by law or appropriate consent has been obtained.</p>
                            <h2>6. Data Security</h2>

        <p>
            Saad Motors Co., Ltd. takes reasonable and appropriate administrative,
            technical, and organizational measures to protect personal information
            from unauthorized access, disclosure, alteration, loss, destruction, or
            other forms of misuse.
        </p>

        <p>
            Access to personal information is limited to authorized personnel and
            parties who require the information for legitimate business purposes.
        </p>

        <p>
            We regularly review and improve our information security practices to
            maintain appropriate protection of personal information.
        </p>


        <h2>7. Data Retention</h2>

        <p>
            Personal information will be retained only for as long as reasonably
            necessary to fulfill the purposes for which it was collected, to maintain
            business records, or to comply with applicable legal, regulatory,
            accounting, or contractual requirements.
        </p>

        <p>
            When personal information is no longer required, we will take reasonable
            steps to securely delete, destroy, or anonymize it in accordance with
            applicable laws and our internal procedures.
        </p>


        <h2>8. Cookies and Website Technologies</h2>

        <p>
            Our website may use cookies and similar technologies to improve website
            functionality, understand website usage, maintain security, and enhance
            the user experience.
        </p>

        <p>
            You may be able to manage or disable cookies through your browser settings.
            However, disabling certain cookies may affect the functionality of some
            website features.
        </p>


        <h2>9. Requests Regarding Personal Information</h2>

        <p>
            Subject to applicable laws and regulations, individuals may have certain
            rights regarding their personal information, including requesting access
            to, correction of, updating, or deletion of their personal information.
        </p>

        <p>
            Requests will be reviewed and handled in accordance with applicable legal
            requirements and our internal procedures.
        </p>


        <h2>10. Changes to This Privacy Policy</h2>

        <p>
            Saad Motors Co., Ltd. may update or revise this Privacy Policy from time
            to time to reflect changes in our business practices, technology, legal
            requirements, or regulatory obligations.
        </p>

        <p>
            Any updated Privacy Policy will be published on our website with the
            revised effective date.
        </p>


        <h2>11. Contact Us</h2>

        <p>
            If you have any questions, concerns, or requests regarding this Privacy
            Policy or the handling of your personal information, please contact us
            through the official contact details provided on the Saad Motors Co., Ltd.
            website.
        </p>

        <p>
            <strong>Saad Motors Co., Ltd. (Thailand)</strong>
        </p>

        <p>
            <strong>Website:</strong>
            <a href="https://www.saadmotors.com" target="_blank">
                www.saadmotors.com
            </a>
        </p>

        <p>
            <strong>Email:</strong>
            <a href="mailto:Info@saadmotors.com">
                Info@saadmotors.com
            </a>
        </p>                        
                        </div>
                    </div>
                </div>
                <div className="col-1 rightcol">
                    {/* <HomeRight /> */}
                </div>
            </div>
        </>
    );
};
export default PrivacyPolicy;